import React from 'react';
import { BrowserRouter, BrowserRouter as Router } from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import 'react-app-polyfill/ie11';

/** Componentes para inicializar el sistema */
import App from './Components/App';
import AppScrollToTop from './Components/Layout/AppScrollToTop';

/** Service worker a */
import * as serviceWorker from './serviceWorker';

/**
 * @function
 * Función principal para renderizar el contenido del componente.
 */
const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <BrowserRouter>
    <AppScrollToTop>
      <Router>
        <App />
      </Router>
    </AppScrollToTop>
  </BrowserRouter>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
